<template>
  <div class="tab-temp extra-pay">
    <div class="title">补缴费用</div>
    <div class="tab-temp-wrap">
      <div class="tab-temp-date">
        <div class="long-name">{{orderDiff.item}}</div>
        <div class="long-name-val total">￥{{orderDiff.diff_fee / 100}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'orderDiffInfo',
  props: {
    orderDiff: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="less" scoped>
@import  '../../assets/less/variable';
.tab-temp{
  background-color: #fff;
  padding-bottom: 1px;
  .title{
    padding: 18px 20px 2px 20px;
    font-weight: 600;
    font-size: 16px;
    margin-top: 15px;
  }

  .tab-temp-wrap{
    font-size: 14px;
    background-color: #fff;
    margin: 0 40px 0 40px;
    &>div{
      margin:16px 0;
      color:#333;
      .long-name {
        width: 135px;
        color: #777;
        float: left;
      }
      .long-name-val {
        margin-left: 135px;
        white-space: pre-wrap;
      }
      .name{
        width: 100px;
        color:#777;
        float: left;
      }
      .value {
        margin-left: 100px;
        white-space: pre-wrap;
      }
      .commens{
        line-height: 18px;
      }
      .total {
        color: #fc7906;
        font-size: 14px;
        font-weight: bold;
      }
    }
    &.border-bottom {
      border-bottom: 1px solid #f0f0f0;
    }
  }

  .node{
    color:#777;
    font-size: 12px;
    margin-left: 10px;
    line-height: 50px;
  }
}
</style>
<style lang="less">
.extra-pay{
  .el-dialog__body{
  }
}
</style>




// WEBPACK FOOTER //
// src/components/order-detail/order-diff-info.vue